import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Settings } from '../settings/settings';
import { Guest, Website, WeddingEvent } from '../website-builder/wedding';
import { GuestStateStore } from '../guest-list/guest.state.store';
import { WebsiteStateStore } from '../website-builder/website.state.store';
import defaultWebsite from "./default-data";
import { Registry } from '../registry/registry';
import { BaseWebsiteTemplate } from '../website/template-base';
import { Gift } from '../gift/gift';
import { SettingsStateStore } from '../settings/settings.state.store';
@Component({
  selector: 'app-website-template-lottie',
  templateUrl: './website-template-lottie.component.html',
  styleUrls: ['./website-template-lottie.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebsiteTemplateLottieComponent  extends BaseWebsiteTemplate implements OnInit, OnDestroy {


  @Input() cssClass = '';
  @Input() website:Website;
  @Input() settings:Settings;
  @Input() gifts:Gift[];
  @Input() registry:Registry;
  @Input() groupedScheduleItems: any = [];
@Input() viewingTranslatedMode = false;
@Input() useDefaultData = false;
  searchName: string;
  @Input()preview;
  rsvpGuestsSearch: Guest[];
  notFound = false;
  showRsvpQuestions = false;
  currentRsvpGuest: Guest;
  currentEventIndex: number = 0;
  currentEvent: any;
  rsvpSubmitted: boolean;
  isInWebsiteBuilder: boolean;
  answeredPlusOne: boolean;
  weddingEventsForGuest: WeddingEvent[];
  currentPartyOfGuests : Guest[];
  respondedPartyOfGuests : Guest[];
  respondedToRsvp: boolean;
  guests: Guest[];
  showRsvp: boolean;
  showTranslation: boolean = false;
  constructor(
    private _guestState: GuestStateStore,
    private _websiteState: WebsiteStateStore,
    private _settingsState: SettingsStateStore,
    private cdr: ChangeDetectorRef
  ) { 
    super(); 
    this.preview = location.search.includes('preview')
    this.isInWebsiteBuilder = location.pathname.toLowerCase().includes('/website/builder');

  }



  updateWebsiteModal(website: Website): void {

    this.website = website;
    this.setScrollForSplitMode();
    this.showRsvp = this._websiteState.processWeddingEventsToShowRsvp(this.website);    
         if(this.cdr && !this.cdr['destroyed']){        
        this.cdr.detectChanges();      
     }

  }
  updateRegistryModal(registry: Registry): void {
    
    this.registry = registry;
         if(this.cdr && !this.cdr['destroyed']){        
        this.cdr.detectChanges();      
     }
  }
  ngOnDestroy(): void {
    const splitCover = document.querySelector('.split-cover');
    if (splitCover) {
      splitCover.removeEventListener('wheel', () => {});
    }
    this.cdr.detach();
  }

  changeLang(){
    this.showTranslation = !  this.showTranslation ;
         if(this.cdr && !this.cdr['destroyed']){        
        this.cdr.detectChanges();      
     }
  }
  setScrollForSplitMode(){
    const splitCover = document.querySelector('.split-cover');
    const scrollingPanels = document.querySelector('.scrolling-panels');
  
    if (splitCover && scrollingPanels) {
      splitCover.addEventListener('wheel', (event: WheelEvent) => {
        event.preventDefault();
        scrollingPanels.scrollTop += event.deltaY;
      });
    }
     
  }
  ngOnInit() {
    
    this._guestState.getState().subscribe(state => {
      this.guests = state.guests;
    })

    this. groupedScheduleItems = this._websiteState.initScheduleList(this.website);

    this._websiteState.tranlsationEmitted$.subscribe(tranlation => {
      
      this.viewingTranslatedMode = tranlation;
      if(this.cdr && !this.cdr['destroyed']){
        
          this.cdr.detectChanges();
        
       }

    });
    if(!this.website || Object.keys(this.website).length === 0){
  
    this.website = defaultWebsite;
  
    }
    this.showRsvp = this._websiteState.processWeddingEventsToShowRsvp(this.website);
;
    if(this.website && this.website.userId){
    this._settingsState.getSettingsViaUserId(this.website.userId).subscribe(settings => {
      if(settings){
      this.settings = settings;

      if(this.settings && this.settings.enableTranslations && this.settings.defaultLanguage!= "English"){
        this.showTranslation = true;
      } 
      if(this.cdr && !this.cdr['destroyed']){        
        this.cdr.detectChanges();      
     }
    }
    })
  }

  }

  getPartySize(guest:Guest):number{
 return this._guestState.getPartySize(guest);
  }
  scrollToSource(locationSection:string){
    if(location.pathname.toLowerCase().includes('/website/builder')){
      this._websiteState.scrollToSource(locationSection);
    }
  }

  nextEvent() {
    // Assuming currentEventIndex is the index of the current event in an array of events
    if (this.currentEventIndex < this.website.weddingEvents.length - 1) {
      this.currentEventIndex++;
      this.currentEvent = this.website.weddingEvents[this.currentEventIndex];
    }
  }

  respondToRsvp(guest:Guest){
    this.currentRsvpGuest = guest;
    if(!this.currentPartyOfGuests && guest.partyName){
      this.currentPartyOfGuests  = this.guests.filter(g => g.partyName === guest.partyName);
      this.respondedPartyOfGuests = [];
    }
  
    
//populate weddingEventsForGuest with the events that the guest is invited to. To do this you must look at the guest.rsvpStatus and see if it is equal to 'invited' or 'attending' or 'declined'
this.weddingEventsForGuest = [];
this.weddingEventsForGuest = this.website.weddingEvents.filter(event => {
  let rsvpStatus = guest.rsvpStatus[event.id];
  return rsvpStatus === 'invited' || rsvpStatus === 'attending' || rsvpStatus === 'declined';
});

;

    this.answeredPlusOne = true;
    this.showRsvpQuestions=true;
    if(this.currentRsvpGuest.canBringPlusOne){
      this.answeredPlusOne = false;
    }
    if (!this.currentRsvpGuest.rsvpResponses) {
      this.currentRsvpGuest.rsvpResponses = {};
      for (let event of this.website.weddingEvents) {
        if (event.rsvpQuestions && event.collectRsvpsOnWebsite) {
        for (let question of event.rsvpQuestions) {
          this.currentRsvpGuest.rsvpResponses[question.id] = '';
        }
      }
      }
    }
  }

  anyGuestSelected() {
    return this.rsvpGuestsSearch.some(guest => guest.selected);
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   console.log(changes);
  //   ;
  //   if (changes.website) {
  //     // this.website = changes.website.currentValue;
  //   //  this.templateId = this.website.template;  
    
      
  //   }
  // }
  searchGuest() {
    this.notFound = false;
   this.rsvpGuestsSearch =  this._guestState.searchGuest(this.searchName);

   //for each guest if they have guest.partyName get the totals of the partySize
    this.rsvpGuestsSearch.forEach(guest => {
      if(guest.partyName){
        let party = this.rsvpGuestsSearch.filter(g => g.partyName === guest.partyName);        
        //add the partySize to an array of partyId vs partySize
        



      }
    })
   
   if(this.rsvpGuestsSearch && this.rsvpGuestsSearch.length == 0){
     this.notFound = true;
   }

   
  }
  editRsvp(guest:Guest){
    this.currentRsvpGuest = guest;
    this.showRsvpQuestions = true;
    this.currentEventIndex = 0;
    this.rsvpSubmitted = false;
  }
  submitRsvp(){
    this.showRsvpQuestions = true;
  }
  saveGuest(){
    console.log(this.currentRsvpGuest)
    this._guestState.updateGuest(this.currentRsvpGuest);

    if(this.currentPartyOfGuests && this.currentPartyOfGuests.length > 0){
      this.upsertIntoRespondedPartyOfGuests(this.currentRsvpGuest)
        this.currentPartyOfGuests = this.currentPartyOfGuests.filter(g => g.id !== this.currentRsvpGuest.id);
        let lastGuest = this.currentPartyOfGuests[0];
        if(lastGuest){
        this.respondToRsvp(lastGuest)
        } 
        else {
          this.rsvpSubmitted = true;
        }
    } else {
      this.rsvpSubmitted = true;
     this.upsertIntoRespondedPartyOfGuests(this.currentRsvpGuest)
    }
    
  }

  openRegistry(isPreview:boolean){
    if(isPreview){
      return window.open('/' + this.registry.registryName +'/registry' + '?preview=1');
    }
    return window.open('/' + this.registry.registryName +'/registry');
  }
  upsertIntoRespondedPartyOfGuests(guest:Guest){
    if(this.respondedPartyOfGuests && this.respondedPartyOfGuests.length > 0){
      let index = this.respondedPartyOfGuests.findIndex(g => g.id === guest.id);
      if(index > -1){
        this.respondedPartyOfGuests[index] = guest;
      } else {
        this.respondedPartyOfGuests.push(guest);
      }
    } else {
      this.respondedPartyOfGuests = [];
      this.respondedPartyOfGuests.push(guest);
    }
  }

  confirmGuest() {
    // Implement your confirmation logic here
  }
  updateResponse(weddingEventId: string, rsvpQuestionId: string, response: string) {
    const responseRsvp = { rsvpQuestionId, weddingEventId, response };
    // this.currentRsvpGuest.rsvpResponses = this.currentRsvpGuest.rsvpResponses || [];
    // this.currentRsvpGuest.rsvpResponses.push(responseRsvp);
    this._guestState.updateGuest(this.currentRsvpGuest);
  }

  formatUrl(url: string): string {
    if (!url) return '';
    
    // If URL already starts with http:// or https://, return as is
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    
    // If URL starts with www. or is just a domain, prefix with https://
    return `https://${url.startsWith('www.') ? '' : 'www.'}${url}`;
  }

  scrollToSection(elementId: string) {
    if (this.isInWebsiteBuilder){

    
    // Small delay to ensure the story section is opened first
    setTimeout(() => {
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }
  }


  getCurrentLocale(): string {
    if (!this.showTranslation) {
      return 'en-US';
    }
    
    // Map language to locale
    const localeMap: { [key: string]: string } = {
      'spanish': 'es',
      'french': 'fr',
      // Add other language mappings as needed
    };

    if(!this.settings.secondLanguage){
      return 'en-US';
    }
    
    return localeMap[this.settings.secondLanguage.toLowerCase()] || 'en-US';
  }
}



// WEBPACK FOOTER //
// ./src/app/website-template-lottie/website-template-lottie.component.ts